import { graphql, useStaticQuery } from "gatsby"

function topicFor(title) {
  if (/cookie|httponly|session|signature|company was wrong|preview failed|code execution|security|pdf/i.test(title)) return "Security"
  if (/games|dungeon|twenty questions|odd bot/i.test(title)) return "Experiments"
  if (/docker|terraform|k3s|infrastructure|scaling|on-call/i.test(title)) return "Systems"
  if (/\bgpt|\bai\b|model|harness|language|mixtral|eight experts/i.test(title)) return "AI"
  return "Development"
}

export function usePreviewPosts() {
  const data = useStaticQuery(graphql`
    query DesignPreviewPosts {
      allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
        nodes {
          id
          html
          excerpt(pruneLength: 220)
          timeToRead
          fields { slug }
          frontmatter {
            title
            description
            path
            draft
            date(formatString: "MMM DD, YYYY")
            year: date(formatString: "YYYY")
          }
        }
      }
    }
  `)

  return data.allMarkdownRemark.nodes.map((node, index, all) => ({
    id: node.id,
    slug: node.fields.slug,
    alias: node.frontmatter.path,
    title: node.frontmatter.title,
    draft: node.frontmatter.draft === true,
    description: node.frontmatter.description || node.excerpt,
    excerpt: node.excerpt,
    html: node.html,
    date: node.frontmatter.date,
    year: node.frontmatter.year,
    timeToRead: node.timeToRead,
    topic: topicFor(node.frontmatter.title),
    number: String(all.length - index).padStart(2, "0"),
  }))
}

export function withPreviewLinks(posts, basePath) {
  const normalize = value => value.replace(/^\/+|\/+$/g, "").toLowerCase()
  const aliases = new Map()
  posts.forEach(post => {
    aliases.set(normalize(post.slug), post.slug)
    if (post.alias) aliases.set(normalize(post.alias), post.slug)
  })
  return posts.map(post => ({
    ...post,
    html: post.html.replace(/href="(\/[^"\s]*)"/g, (attribute, href) => {
      const [pathname, hash] = href.split("#")
      const slug = aliases.get(normalize(pathname))
      return slug ? `href="${basePath}${slug}${hash ? `#${hash}` : ""}"` : attribute
    }),
  }))
}

export const concepts = [
  { id: "margin-notes", number: "01", name: "Margin Notes", caption: "A journal with room to think.", description: "Ivory paper, ink-blue type, and a conversation in the margins. Explore the notes, then settle into a quiet reading view." },
  { id: "snail-trails", number: "02", name: "Snail Trails", caption: "Follow a thread of curiosity.", description: "A cartographic view of ideas. Pick a trail, explore its stops, and move between the map and the complete archive." },
  { id: "cross-section", number: "03", name: "Cross Section", caption: "Questions. Experiments. Findings.", description: "An architectural journal in oxblood and warm white. Unfold a subject and browse the questions behind the experiments." },
  { id: "quiet-notes", number: "04", round: 2, name: "Quiet Notes", caption: "Straight into the notebook.", description: "The snail you liked, the margins you liked, and the writing right at the top. A compact, quietly expressive journal." },
  { id: "reading-desk", number: "05", round: 2, name: "Reading Desk", caption: "Browse on the left. Read on the right.", description: "A compact split view: choose a headline and settle into its opening beside the archive. Paper, olive ink, and room for the words." },
  { id: "field-index", number: "06", round: 2, name: "Field Index", caption: "A small index. A wide-open notebook.", description: "A slim navigation rail, a chronological notebook, and a margin for the selected story. Follow a topic or a year without the long introduction." },
]
